import { render, staticRenderFns } from "./blueDetailItem.vue?vue&type=template&id=bef53ca6&scoped=true&"
import script from "./blueDetailItem.vue?vue&type=script&lang=js&"
export * from "./blueDetailItem.vue?vue&type=script&lang=js&"
import style0 from "./blueDetailItem.vue?vue&type=style&index=0&id=bef53ca6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef53ca6",
  null
  
)

export default component.exports